import styled from '@emotion/styled'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'

import StatusBanner from './StatusBanner'
import { useInstallPrompt } from 'hooks/useInstallPrompt'
import { useTracking } from 'hooks/useTracking'
import { EVENT_NAMES } from 'lib/tracking'

export const LinkButton = styled(Link)`
	padding: ${({ theme }) => `${theme.spaces.space3} ${theme.spaces.space5}`};
	font-weight: 400;
	margin-top: ${({ theme }) => theme.spaces.space4};
	background-color: ${({ theme }) => theme.colors.light.surfaceInteractive};
	display: inline-flex;
	align-items: center;
	border-radius: ${({ theme }) => theme.borderRadiuses.lg};
	text-decoration: none;
	color: ${({ theme }) => theme.colors.dark.primaryTextColor};
	${({ theme }) => theme.typography.caption}

	@media (hover: hover) {
		will-change: transform;
		transition: transform 150ms ease-out;
		&:hover {
			transform: scale(1.1);
		}
	}
`

export const IconWrapper = styled.div`
	display: flex;
	margin-left: ${({ theme }) => theme.spaces.space2};
`

function InstallPrompt() {
	const track = useTracking()
	const { tutorial, isVisible } = useInstallPrompt()
	const router = useRouter()
	const [, , sectionName] = router.pathname.split('/')

	const onLinkClick = () => {
		if (!tutorial) {
			return
		}
		track(EVENT_NAMES.INSTALL_PROMPT_LINK_CLICKED, { link: tutorial.name, sectionName })
	}

	return (
		<StatusBanner type="warning" isVisible={isVisible} title="Widget not installed">
			{tutorial ? (
				<>
					{`Install the widget on your ${tutorial.name} ${
						tutorial.isEcommerce ? 'store' : 'website'
					} and start getting messages from customers`}
					<LinkButton rel="noopener,noreferrer" target="_blank" onClick={onLinkClick} href={tutorial.articleURL}>
						{`Check ${tutorial.name} install guide`}
						<IconWrapper>
							<Image height="16" width="16" src={tutorial.logoDark} alt={tutorial.name} />
						</IconWrapper>
					</LinkButton>
				</>
			) : (
				`Install the widget on your website and start getting messages from customers. Just copy the code below and paste it into your website code.`
			)}
		</StatusBanner>
	)
}

export default InstallPrompt
